module.exports = __webpack_public_path__ + "img/Prisma.1cc21550.svg";